import { Badge } from '@elkaso-app/web-design';
import { getProcessingStatusStyle, processingStatusLabels } from 'pages/invoice-scanning/utils/invoice-scan-status';

export interface IProcessingStatusBadge {
  status: string;
}

export const ProcessingStatusBadge = ({ status }: IProcessingStatusBadge) => {
  const style = getProcessingStatusStyle(status);
  const label = processingStatusLabels[status as keyof typeof processingStatusLabels] || status;

  return (
    <Badge px='sm' py='xs' borderRadius='md' fontSize='xs' fontWeight='semibold' color={style.color} bg={style.bgColor}>
      {label}
    </Badge>
  );
};
